export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';

export const SET_USERNAME = 'SET_USERNAME';

export const SET_PAYMENT_PLAN_TYPE = 'SET_PAYMENT_PLAN_TYPE';

export const SET_SUBSCRIPTION_METHOD = 'SET_SUBSCRIPTION_METHOD';

export const SET_LANDING_SCROLL_POSITION = 'SET_LANDING_SCROLL_POSITION';

export const SET_GIFT_FORM_STATUS = 'SET_GIFT_FORM_STATUS';

export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_CREDIT_CARD_DATA = 'SET_CREDIT_CARD_DATA';

export const SET_SCHEDULE_DATA = 'SET_SCHEDULE_DATA';

export const SET_EXERCISES_DATA = 'SET_EXERCISES_DATA';



// WEBPACK FOOTER //
// ./src/redux/actions.js